export enum HelpfulOption {
  HELP_FINDING_PROVIDER = "HELP_FINDING_PROVIDER",
  CHAT_FERTILITY = "CHAT_FERTILITY",
  CHAT_HEALTH = "CHAT_HEALTH",
  DOULA_INFO = "DOULA_INFO",
  DOULA_POSTPARTUM_INFO = "DOULA_POSTPARTUM_INFO",
  EMOTIONAL_SUPPORT = "EMOTIONAL_SUPPORT",
  PRENATAL_YOGA = "PRENATAL_YOGA",
  LEARN_MILK_SHIPPING = "LEARN_MILK_SHIPPING",
  SUPPORT_LACTATION_INFANT_FEEDING = "SUPPORT_LACTATION_INFANT_FEEDING",
  LGBTQ_FAMILY = "LGBTQ_FAMILY",
  FINANCE_INFO = "FINANCE_INFO",
  FINANCIAL_CONCERNS_JOURNEY_COST = "FINANCIAL_CONCERNS_JOURNEY_COST",
  NOT_SURE = "NOT_SURE",
  PRENATAL_HEALTH_WELLNESS = "PRENATAL_HEALTH_WELLNESS",
  FETAL_DEVELOPMENT = "FETAL_DEVELOPMENT",
  HIGH_RISK_PREGNANCY = "HIGH_RISK_PREGNANCY",
  EARLY_BIRTH_PLANNING = "EARLY_BIRTH_PLANNING",
  BIRTH_OPTIONS_SETTINGS = "BIRTH_OPTIONS_SETTINGS",
  BIRTH_PLAN_RESOURCES = "BIRTH_PLAN_RESOURCES",
  PREGNANCY_SUPPORT_TEAM = "PREGNANCY_SUPPORT_TEAM",
  PHYSICAL_PREPARATION = "PHYSICAL_PREPARATION",
  EMOTIONAL_PREPARATION = "EMOTIONAL_PREPARATION",
  PARENTAL_LEAVE_PLAN = "PARENTAL_LEAVE_PLAN",
  ADVANCED_MATERNAL_AGE = "ADVANCED_MATERNAL_AGE",
  DIABETES_MANAGEMENT = "DIABETES_MANAGEMENT",
  BLOOD_PRESSURE_MANAGEMENT = "BLOOD_PRESSURE_MANAGEMENT",
  CHRONIC_CONDITIONS = "CHRONIC_CONDITIONS",
  MULTIPLE_FETUSES = "MULTIPLE_FETUSES",
  UTERINE_CONDITIONS = "UTERINE_CONDITIONS",
  HIGH_RISK_PREGNANCY_HISTORY = "HIGH_RISK_PREGNANCY_HISTORY",
  PRIOR_COMPLICATED_BIRTH = "PRIOR_COMPLICATED_BIRTH",
  FIRST_TRIMESTER_DEVELOPMENT = "FIRST_TRIMESTER_DEVELOPMENT",
  GENETIC_SCREENING = "GENETIC_SCREENING",
  GENETIC_SCREENING_PRENATAL_TESTING = "GENETIC_SCREENING_PRENATAL_TESTING",
  ULTRASOUND_IMAGING = "ULTRASOUND_IMAGING",
  PREGNANCY_RISKS_COMPLICATIONS = "PREGNANCY_RISKS_COMPLICATIONS",
  PREGNANCY_WARNING_SIGNS = "PREGNANCY_WARNING_SIGNS",
  PREGNANCY_EXERCISE = "PREGNANCY_EXERCISE",
  PREGNANCY_DISCOMFORTS = "PREGNANCY_DISCOMFORTS",
  STRESS_MANAGEMENT = "STRESS_MANAGEMENT",
  SLEEP_FATIGUE = "SLEEP_FATIGUE",
  MEDICATION_SUPPLEMENTS = "MEDICATION_SUPPLEMENTS",
  PRENATAL_EDUCATION = "PRENATAL_EDUCATION",
  SECOND_TRIMESTER_DEVELOPMENT = "SECOND_TRIMESTER_DEVELOPMENT",
  FETAL_MOVEMENT = "FETAL_MOVEMENT",
  BIRTH_PREPARATION = "BIRTH_PREPARATION",
  VAGINAL_BIRTH_AFTER_CESAREAN = "VAGINAL_BIRTH_AFTER_CESAREAN",
  SIGNS_OF_LABOR = "SIGNS_OF_LABOR",
  STAGES_OF_LABOR = "STAGES_OF_LABOR",
  PAIN_MANAGEMENT = "PAIN_MANAGEMENT",
  POSTPARTUM_PLAN = "POSTPARTUM_PLAN",
  BREASTFEEDING_INFO = "BREASTFEEDING_INFO",
  HIGH_BLOOD_PRESSURE_PREECLAMPSIA = "HIGH_BLOOD_PRESSURE_PREECLAMPSIA",
  BREECH_POSITION = "BREECH_POSITION",
  PLANNED_CESAREAN = "PLANNED_CESAREAN",
  THIRD_TRIMESTER_DEVELOPMENT = "THIRD_TRIMESTER_DEVELOPMENT",
  POSTPARTUM_PHYSICAL_HEALTH = "POSTPARTUM_PHYSICAL_HEALTH",
  POSTPARTUM_MENTAL_HEALTH = "POSTPARTUM_MENTAL_HEALTH",
  RETURN_TO_WORK = "RETURN_TO_WORK",
  RETURN_TO_WORK_PLAN = "RETURN_TO_WORK_PLAN",
  PARENTAL_LEAVE_RETURN_TO_WORK_PLAN = "PARENTAL_LEAVE_RETURN_TO_WORK_PLAN",
  EMOTIONAL_CHALLENGES_WORK = "EMOTIONAL_CHALLENGES_WORK",
  MANAGER_CONVERSATIONS = "MANAGER_CONVERSATIONS",
  WORK_LIFE_BALANCE = "WORK_LIFE_BALANCE",
  SLEEP_DEPRIVATION_WORK = "SLEEP_DEPRIVATION_WORK",
  PUMPING_AT_WORK = "PUMPING_AT_WORK",
  REMOTE_WORK_NEWBORN = "REMOTE_WORK_NEWBORN",
  LATCH_POSITION = "LATCH_POSITION",
  MILK_SUPPLY = "MILK_SUPPLY",
  NIPPLE_SORENESS = "NIPPLE_SORENESS",
  MILK_PUMPING_STORAGE = "MILK_PUMPING_STORAGE",
  INDUCED_LACTATION = "INDUCED_LACTATION",
  COMBINATION_FEEDING = "COMBINATION_FEEDING",
  CESAREAN_RECOVERY_FEEDING = "CESAREAN_RECOVERY_FEEDING",
  NICU_FEEDING = "NICU_FEEDING",
  RETURN_TO_WORK_FEEDING = "RETURN_TO_WORK_FEEDING",
  NEW_PARENT_EMOTIONS = "NEW_PARENT_EMOTIONS",
  PERINATAL_MOOD_DISORDERS = "PERINATAL_MOOD_DISORDERS",
  TRAUMATIC_BIRTH = "TRAUMATIC_BIRTH",
  BIRTH_IN_NICU = "BIRTH_IN_NICU",
  SELF_CARE = "SELF_CARE",
  FINDING_HELP_SUPPORT = "FINDING_HELP_SUPPORT",
  POSTPARTUM_WARNING_SIGNS = "POSTPARTUM_WARNING_SIGNS",
  VAGINAL_DELIVERY_DISCOMFORT = "VAGINAL_DELIVERY_DISCOMFORT",
  CESAREAN_BIRTH_RECOVERY = "CESAREAN_BIRTH_RECOVERY",
  POSTPARTUM_CHECKUPS = "POSTPARTUM_CHECKUPS",
  PELVIC_HEALTH = "PELVIC_HEALTH",
  SLEEP_FATIGUE_MANAGEMENT = "SLEEP_FATIGUE_MANAGEMENT",
  FAMILY_PLANNING = "FAMILY_PLANNING",
  DOULA_GENERAL_INFO = "DOULA_GENERAL_INFO",
  FERTILITY_BASICS = "FERTILITY_BASICS",
  COMMON_FERTILITY_CHALLENGES = "COMMON_FERTILITY_CHALLENGES",
  PRE_PREGNANCY_HEALTH = "PRE_PREGNANCY_HEALTH",
  IMPROVING_METABOLIC_HEALTH = "IMPROVING_METABOLIC_HEALTH",
  RELATIONSHIP_SUPPORT = "RELATIONSHIP_SUPPORT",
  OVULATION_TRACKING = "OVULATION_TRACKING",
  HORMONAL_CONTRACEPTION_AND_FERTILITY = "HORMONAL_CONTRACEPTION_AND_FERTILITY",
  LGBTQIA_PLUS_SUPPORT = "LGBTQIA_PLUS_SUPPORT",
  TRANSGENDER_FERTILITY_CONSIDERATIONS = "TRANSGENDER_FERTILITY_CONSIDERATIONS",
  SPERM_HEALTH = "SPERM_HEALTH",
  VASECTOMY_REVERSAL = "VASECTOMY_REVERSAL",
  POLYCYSTIC_OVARY_SYNDROME_PCOS = "POLYCYSTIC_OVARY_SYNDROME_PCOS",
  ENDOMETRIOSIS = "ENDOMETRIOSIS",
  LOW_OR_HIGH_BMI = "LOW_OR_HIGH_BMI",
  UTERINE_DISORDERS = "UTERINE_DISORDERS",
  DIMINISHED_OVARIAN_RESERVE = "DIMINISHED_OVARIAN_RESERVE",
  TUBAL_FACTOR = "TUBAL_FACTOR",
  RECURRENT_PREGNANCY_LOSS = "RECURRENT_PREGNANCY_LOSS",
  ADVANCED_MATERNAL_AGE_35_PLUS = "ADVANCED_MATERNAL_AGE_35_PLUS",
  EARLY_MENOPAUSE_OR_PRIMARY_OVARIAN_INSUFFICIENCY = "EARLY_MENOPAUSE_OR_PRIMARY_OVARIAN_INSUFFICIENCY",
  UNEXPLAINED_INFERTILITY = "UNEXPLAINED_INFERTILITY",
  ERECTILE_DYSFUNCTION = "ERECTILE_DYSFUNCTION",
  NUTRITION = "NUTRITION",
  SUPPLEMENTS_FOR_PRE_PREGNANCY = "SUPPLEMENTS_FOR_PRE_PREGNANCY",
  OPTIMIZING_EGG_HEALTH = "OPTIMIZING_EGG_HEALTH",
  OPTIMIZING_SPERM_HEALTH = "OPTIMIZING_SPERM_HEALTH",
  MEDICATION_SAFETY = "MEDICATION_SAFETY",
  GLP1_TRYING_TO_GET_PREGNANT = "GLP1_TRYING_TO_GET_PREGNANT",
  PRE_EXISTING_MEDICAL_CONDITIONS = "PRE_EXISTING_MEDICAL_CONDITIONS",
  PRE_EXISTING_MEDICAL_METABOLIC_CONDITIONS = "PRE_EXISTING_MEDICAL_METABOLIC_CONDITIONS",
  KNOWN_GENETIC_OR_HEREDITARY_CONDITIONS = "KNOWN_GENETIC_OR_HEREDITARY_CONDITIONS",
  IMPROVING_FERTILITY_WITHOUT_MEDICAL_INTERVENTIONS = "IMPROVING_FERTILITY_WITHOUT_MEDICAL_INTERVENTIONS",
  TESTING_AND_CONSULTATIONS = "TESTING_AND_CONSULTATIONS",
  HELP_PREPARING_FOR_AN_APPOINTMENT = "HELP_PREPARING_FOR_AN_APPOINTMENT",
  INITIAL_CONSULTATIONS = "INITIAL_CONSULTATIONS",
  FERTILITY_EVALUATION = "FERTILITY_EVALUATION",
  OVARIAN_RESERVE_TESTING = "OVARIAN_RESERVE_TESTING",
  SEMEN_ANALYSIS = "SEMEN_ANALYSIS",
  TRANSVAGINAL_ULTRASOUND = "TRANSVAGINAL_ULTRASOUND",
  UTERINE_SCREENING = "UTERINE_SCREENING",
  GENETIC_CARRIER_SCREENING = "GENETIC_CARRIER_SCREENING",
  ASSISTED_REPRODUCTION_BASICS = "ASSISTED_REPRODUCTION_BASICS",
  DONOR_ASSISTANCE = "DONOR_ASSISTANCE",
  UNDERSTANDING_IUI = "UNDERSTANDING_IUI",
  UNDERSTANDING_IVF = "UNDERSTANDING_IVF",
  FAITH_INCLUSIVE_CARE = "FAITH_INCLUSIVE_CARE",
  SINGLE_INTENDED_PARENT_SUPPORT = "SINGLE_INTENDED_PARENT_SUPPORT",
  MALE_FACTOR_INFERTILITY = "MALE_FACTOR_INFERTILITY",
  DONOR_EGGS = "DONOR_EGGS",
  DONOR_SPERM = "DONOR_SPERM",
  GESTATIONAL_SURROGACY_BASICS = "GESTATIONAL_SURROGACY_BASICS",
  PREPARING_FOR_IUI = "PREPARING_FOR_IUI",
  ADMINISTERING_MEDICATION = "ADMINISTERING_MEDICATION",
  POLYCYSTIC_OVARY_SYNDROME = "POLYCYSTIC_OVARY_SYNDROME",
  FAITH_INCLUSIVE_OPTIONS_FOR_SEMEN_COLLECTION = "FAITH_INCLUSIVE_OPTIONS_FOR_SEMEN_COLLECTION",
  GLP1_FERTILITY_TREATMENTS = "GLP1_FERTILITY_TREATMENTS",
  PREPARING_FOR_IVF = "PREPARING_FOR_IVF",
  EMBRYO_GRADING = "EMBRYO_GRADING",
  GENETIC_TESTING_OPTIONS = "GENETIC_TESTING_OPTIONS",
  OVARIAN_STIMULATION = "OVARIAN_STIMULATION",
  EGG_RETRIEVAL = "EGG_RETRIEVAL",
  RECIPROCAL_IVF = "RECIPROCAL_IVF",
  FRESH_VS_FROZEN_EMBRYO_TRANSFER = "FRESH_VS_FROZEN_EMBRYO_TRANSFER",
  SINGLE_VS_MULTIPLE_EMBRYO_TRANSFER = "SINGLE_VS_MULTIPLE_EMBRYO_TRANSFER",
  FERTILIZATION_METHODS = "FERTILIZATION_METHODS",
  MINIMUM_STIMULATION_AND_NATURAL_CYCLES = "MINIMUM_STIMULATION_AND_NATURAL_CYCLES",
  HELP_NAVIGATING_NEXT_STEPS = "HELP_NAVIGATING_NEXT_STEPS",
  EMBRYO_STORAGE_AND_CRYOSHIPPING = "EMBRYO_STORAGE_AND_CRYOSHIPPING",
  FROZEN_EMBRYO_TRANSFERS = "FROZEN_EMBRYO_TRANSFERS",
  PARENT_SELF_CARE = "PARENT_SELF_CARE",
  INFANT_LIFESTYLE = "INFANT_LIFESTYLE",
  INFANT_HEALTH_NUTRITION_AND_SAFETY = "INFANT_HEALTH_NUTRITION_AND_SAFETY",
  SHIPPING_BREAST_CHEST_MILK = "SHIPPING_BREAST_CHEST_MILK",
  INFANT_HEALTH_OR_MEDICAL_CONDITION = "INFANT_HEALTH_MEDICAL_CONDITION",
  DEVELOPMENTAL_MILESTONES = "DEVELOPMENTAL_MILESTONES",
  SAFETY_CHILDPROOFING = "SAFETY_CHILDPROOFING",
  PREPARING_FORMULA = "PREPARING_FORMULA",
  BOTTLE_FEEDING = "BOTTLE_FEEDING",
  BABY_LED_WEANING = "BABY_LED_WEANING",
  INTRODUCING_SOLID_FOOD = "INTRODUCING_SOLID_FOOD",
  BATHING_DIAPERING_SWADDLING = "BATHING_DIAPERING_SWADDLING",
  SAFE_SLEEP_GUIDELINES = "SAFE_SLEEP_GUIDELINES",
  COMFORT_TECHNIQUES_CRYING_FUSSINESS = "COMFORT_TECHNIQUES_CRYING_FUSSINESS",
  INFANT_SLEEP_SLEEP_TRAINING = "INFANT_SLEEP_SLEEP_TRAINING",
  INFANT_BEHAVIORS = "INFANT_BEHAVIORS",
  POSTPARTUM_HEALTH_NUTRITION_LIFESTYLE = "POSTPARTUM_HEALTH_NUTRITION_LIFESTYLE",
  NEW_PARENT_EMOTIONS_MENTAL_HEALTH = "NEW_PARENT_EMOTIONS_MENTAL_HEALTH",
  PREMATURE_SICK_SPECIAL_NEEDS_INFANT = "PREMATURE_SICK_SPECIAL_NEEDS_INFANT",
  BREAST_CHESTFEEDING_SUPPORT = "BREAST_CHESTFEEDING_SUPPORT",
  BREAST_CHESTFEEDING_AFTER_RETURNING_TO_WORK = "BREAST_CHESTFEEDING_AFTER_RETURNING_TO_WORK",
  FINDING_CHILDCARE = "FINDING_CHILDCARE",
  CHILD_LIFESTYLE = "CHILD_LIFESTYLE",
  CHILD_HEALTH_NUTRITION_SAFETY = "CHILD_HEALTH_NUTRITION_SAFETY",
  CHILDPROOFING = "CHILDPROOFING",
  SCREEN_TIME_INTERNET_SAFETY = "SCREEN_TIME_INTERNET_SAFETY",
  CHILD_HEALTH_MEDICAL_CONDITION = "CHILD_HEALTH_MEDICAL_CONDITION",
  CHOOSY_EATERS = "CHOOSY_EATERS",
  CHILD_BEHAVIOR_CHALLENGES = "CHILD_BEHAVIOR_CHALLENGES",
  TRANSITIONING_CRIB_TO_BED = "TRANSITIONING_CRIB_TO_BED",
  POTTY_TRAINING = "POTTY_TRAINING",
  PREPARING_CHILD_FOR_SIBLING = "PREPARING_CHILD_FOR_SIBLING",
  PARENT_EMOTIONS_MENTAL_HEALTH = "PARENT_EMOTIONS_MENTAL_HEALTH",
  PARENTING_CHILD_SPECIAL_NEEDS = "PARENTING_CHILD_SPECIAL_NEEDS",
  BALANCING_PARENTHOOD_CAREER = "BALANCING_PARENTHOOD_CAREER",
  SLEEP_HABITS_REGRESSION = "SLEEP_HABITS_REGRESSION",
  BULLYING_SCHOOL_CONFLICT = "BULLYING_SCHOOL_CONFLICT",
  PHYSICAL_EMOTIONAL_CHANGES_PUBERTY = "PHYSICAL_EMOTIONAL_CHANGES_PUBERTY",
  NUTRITION_CHOOSY_EATERS = "NUTRITION_CHOOSY_EATERS",
  PHYSICAL_ACTIVITY_EXERCISE = "PHYSICAL_ACTIVITY_EXERCISE",
  RETURNING_TO_WORK_WITH_OLDER_CHILDREN = "RETURNING_TO_WORK_WITH_OLDER_CHILDREN",
  EMOTIONS_AROUND_RETURNING_TO_WORK = "EMOTIONS_AROUND_RETURNING_TO_WORK",
  MENOPAUSE_SYMPTOMS = "MENOPAUSE_SYMPTOMS",
  TREATMENT_OPTIONS = "TREATMENT_OPTIONS",
  NUTRITION_WEIGHT_MANAGEMENT_SUPPORT = "NUTRITION_WEIGHT_MANAGEMENT_SUPPORT",
  FERTILITY_PRESERVATION = "FERTILITY_PRESERVATION",
  ASSISTED_REPRODUCTION = "ASSISTED_REPRODUCTION",
  COPING_SYMTOMS_AT_WORK = "COPING_SYMTOMS_AT_WORK",
  HORMONE_THERAPY_TREATMENT_OPTIONS = "HORMONE_THERAPY_TREATMENT_OPTIONS",
  MEMORY_FOCUS_COGNITIVE_ISSUES = "MEMORY_FOCUS_COGNITIVE_ISSUES",
  LOSS_OF_LIBIDO_SEXUAL_ISSUES = "LOSS_OF_LIBIDO_SEXUAL_ISSUES",
  IMPROVING_SLEEP = "IMPROVING_SLEEP",
  URINARY_FREQUENCY_URGENCY = "URINARY_FREQUENCY_URGENCY",
  BONE_HEART_HEALTH = "BONE_HEART_HEALTH",
  ORAL_HEALTH = "ORAL_HEALTH",
  LOW_TESTOSTERONE = "LOW_TESTOSTERONE",
  WEIGHT_LOSS_MEDS_MENOPAUSE = "WEIGHT_LOSS_MEDS_MENOPAUSE",
  SUPPLEMENTS_ALTERNATIVE_MEDS = "SUPPLEMENTS_ALTERNATIVE_MEDS",
  SPERM_PRESERVATION = "SPERM_PRESERVATION",
  EGG_PRESERVATION = "EGG_PRESERVATION",
  BASELINE_FERTILITY_TESTING = "BASELINE_FERTILITY_TESTING",
  PRESERVATION_BEFORE_MEDICAL_PROCEDURE = "PRESERVATION_BEFORE_MEDICAL_PROCEDURE",
  PRESERVATION_PROCESS = "PRESERVATION_PROCESS",
  PREPARING_FOR_EGG_PRESERVATION = "PREPARING_FOR_EGG_PRESERVATION",
  CRYOBANK_CRYOSHIPPING_INFO = "CRYOBANK_CRYOSHIPPING_INFO",
  PREPARING_FOR_EGG_RETRIEVAL = "PREPARING_FOR_EGG_RETRIEVAL",
  PREPARING_FOR_SPERM_RETRIEVAL = "PREPARING_FOR_SPERM_RETRIEVAL",
  INJECTION_GUIDANCE = "INJECTION_GUIDANCE",
  OPTIONS_FOR_SEMEN_COLLECTION = "OPTIONS_FOR_SEMEN_COLLECTION",
  PREIMPLANTATION_GENETIC_TESTING = "PREIMPLANTATION_GENETIC_TESTING",
  PREPARING_FOR_SPERM_PRESERVATION = "PREPARING_FOR_SPERM_PRESERVATION",
  TALK_ADOPTION_EXPERT = "TALK_ADOPTION_EXPERT",
  FIND_ADOPTION_AGENCY = "FIND_ADOPTION_AGENCY",
  DOMESTIC_ADOPTION = "DOMESTIC_ADOPTION",
  INTERNATIONAL_ADOPTION = "INTERNATIONAL_ADOPTION",
  FOSTER_CARE_ADOPTION = "FOSTER_CARE_ADOPTION",
  ADOPTION_PROCESS_STEPS = "ADOPTION_PROCESS_STEPS",
  ADOPTION_JOURNEY_LENGTH = "ADOPTION_JOURNEY_LENGTH",
  ADOPTION_JOURNEY_COST = "ADOPTION_JOURNEY_COST",
  ADOPTION_PROVIDER_TYPES = "ADOPTION_PROVIDER_TYPES",
  NEWBORN_ADOPTION = "NEWBORN_ADOPTION",
  ADOPTION_LEGAL_CONSIDERATIONS = "ADOPTION_LEGAL_CONSIDERATIONS",
  ADOPTION_BASICS = "ADOPTION_BASICS",
  ADOPTION_AGENCY_QUESTIONS = "ADOPTION_AGENCY_QUESTIONS",
  ADOPTION_ATTORNEY_QUESTIONS = "ADOPTION_ATTORNEY_QUESTIONS",
  ADOPTION_MATCHING_PROCESS = "ADOPTION_MATCHING_PROCESS",
  ADOPTIVE_PARENT_PROFILE = "ADOPTIVE_PARENT_PROFILE",
  ADOPTION_BIRTH_PLANNING = "ADOPTION_BIRTH_PLANNING",
  ADOPTION_LEGAL_FINALIZATION = "ADOPTION_LEGAL_FINALIZATION",
  POST_ADOPTION_EMOTIONS = "POST_ADOPTION_EMOTIONS",
  PARENTING_AFTER_ADOPTION = "PARENTING_AFTER_ADOPTION",
  POST_PLACEMENT_SUPERVISION = "POST_PLACEMENT_SUPERVISION",
  CARING_FOR_NEWBORN = "CARING_FOR_NEWBORN",
  CARING_FOR_CHILD = "CARING_FOR_CHILD",
  TALKING_ABOUT_ADOPTION = "TALKING_ABOUT_ADOPTION",
  ADOPTION_FUTURE_PLANNING = "ADOPTION_FUTURE_PLANNING",
  EXPLORING_DIFFERENT_PATHS_TO_PARENTHOOD = "EXPLORING_DIFFERENT_PATHS_TO_PARENTHOOD",
  CONTRACEPTION_OPTIONS = "CONTRACEPTION_OPTIONS",
  FERTILITY_TESTING = "FERTILITY_TESTING",
  IMPROVING_FERTILITY_HEALTH = "IMPROVING_FERTILITY_HEALTH",
  IRREGULAR_CYCLES = "IRREGULAR_CYCLES",
  WEIGHT_LOSS_MEDS_FERTILITY = "WEIGHT_LOSS_MEDS_FERTILITY",
  PREPARING_FOR_PREGNANCY = "PREPARING_FOR_PREGNANCY",
  ADOPTION = "ADOPTION",
  GESTATIONAL_SURROGACY = "GESTATIONAL_SURROGACY",
  PREGNANCY_LOSS = "PREGNANCY_LOSS",
  GESTATIONAL_SURROGACY_STEPS = "GESTATIONAL_SURROGACY_STEPS",
  ASSISTED_REPRODUCTION_SUPPORT = "ASSISTED_REPRODUCTION_SUPPORT",
  GESTATIONAL_SURROGACY_LEGAL_CONSIDERATIONS = "GESTATIONAL_SURROGACY_LEGAL_CONSIDERATIONS",
  BENEFITS_WORKING_WITH_AGENCY = "BENEFITS_WORKING_WITH_AGENCY",
  HOW_CHOOSE_GESTATIONAL_SURROGACY_AGENCY = "HOW_CHOOSE_GESTATIONAL_SURROGACY_AGENCY",
  GESTATIONAL_SURROGACY_WITHOUT_AGENCY = "GESTATIONAL_SURROGACY_WITHOUT_AGENCY",
  GESTATIONAL_CARRIER_MATCHING_PROCESS = "GESTATIONAL_CARRIER_MATCHING_PROCESS",
  CREATING_INTENDED_PARENT_PROFILE = "CREATING_INTENDED_PARENT_PROFILE",
  BIRTH_PLANNING_PREP_INTENDED_PARENTS = "BIRTH_PLANNING_PREP_INTENDED_PARENTS",
  FETAL_DEVELOPMENT_PRENATAL_CARE = "FETAL_DEVELOPMENT_PRENATAL_CARE",
  POST_BIRTH_EMOTIONS_MENTAL_HEALTH = "POST_BIRTH_EMOTIONS_MENTAL_HEALTH",
  NEWBORN_CARE = "NEWBORN_CARE",
  FETAL_DEVELOPMENT_STAGES = "FETAL_DEVELOPMENT_STAGES",
  HIGH_RISK_PREGNANCY_MULTIPLE_FETUSES = "HIGH_RISK_PREGNANCY_MULTIPLE_FETUSES",
  TRAVEL_CONSIDERATIONS = "TRAVEL_CONSIDERATIONS",
  PRENATAL_EDUCATION_PARENTING_CLASSES = "PRENATAL_EDUCATION_PARENTING_CLASSES",
  LOW_TESTOSTERONE_SYMPTOMS = "LOW_TESTOSTERONE_SYMPTOMS",
  LOW_TESTOSTERONE_TREATMENT_OPTIONS = "LOW_TESTOSTERONE_TREATMENT_OPTIONS",
  COPING_WITH_SYMPTOMS = "COPING_WITH_SYMPTOMS",
  SLEEP_APNEA_SLEEP_ISSUES = "SLEEP_APNEA_SLEEP_ISSUES",
  CARDIOVASCULAR_HEALTH = "CARDIOVASCULAR_HEALTH",
  LOW_TESTOSTERONE_PERI_MENOPAUSE = "LOW_TESTOSTERONE_PERI_MENOPAUSE",
  MEDICAL_OR_HEALTH_RELATED_QUESTIONS = "MEDICAL_OR_HEALTH_RELATED_QUESTIONS",
  GENDER_EXPLORATION_EMBODIMENT = "GENDER_EXPLORATION_EMBODIMENT",
  FEMINIZING_HORMONE_THERAPY = "FEMINIZING_HORMONE_THERAPY",
  MASCULINIZING_HORMONE_THERAPY = "MASCULINIZING_HORMONE_THERAPY",
  SOCIAL_AFFIRMATION = "SOCIAL_AFFIRMATION",
  MEDICAL_AFFIRMATION = "MEDICAL_AFFIRMATION",
  LEGAL_AFFIRMATION = "LEGAL_AFFIRMATION",
  BINDERS_AND_TUCKING_GARMENTS = "BINDERS_AND_TUCKING_GARMENTS",
  VOICE_THERAPY = "VOICE_THERAPY",
  HAIR_REMOVAL = "HAIR_REMOVAL",
  NON_HORMONAL_GENDER_AFFIRMING_CARE_OPTIONS = "NON_HORMONAL_GENDER_AFFIRMING_CARE_OPTIONS",
  OTHER_FERTILITY_QUESTIONS = "OTHER_FERTILITY_QUESTIONS",
  HELP_FINDING_OBSTETRIC_PROVIDER = "HELP_FINDING_OBSTETRIC_PROVIDER",
  HELP_FINDING_DOULA = "HELP_FINDING_DOULA",
  HELP_FINDING_PEDIATRICIAN = "HELP_FINDING_PEDIATRICIAN",
  PEDIATRIC_TELEMEDICINE = "PEDIATRIC_TELEMEDICINE",
  PELVIC_FLOOR_THERAPY = "PELVIC_FLOOR_THERAPY",
  PELVIC_FLOOR_HEALTH = "PELVIC_FLOOR_HEALTH",
  PELVIC_FLOOR_DYSFUNCTION = "PELVIC_FLOOR_DYSFUNCTION",
  PELVIC_PAIN = "PELVIC_PAIN",
  URINARY_INCONTINENCE = "URINARY_INCONTINENCE",
  RECTAL_DISORDERS = "RECTAL_DISORDERS",
  ORGAN_PROLAPSE = "ORGAN_PROLAPSE",
  ERECTILE_FUNCTION = "ERECTILE_FUNCTION",

  // start: deprecated WWBMH options
  DISCUSS_OPTIONS = "DISCUSS_OPTIONS",
  HELP_PATHWAY = "HELP_PATHWAY",
  CHAT_LIFESTYLE = "CHAT_LIFESTYLE",
  DOULA_BIRTH_INFO = "DOULA_BIRTH_INFO",
  HELP_NICU = "HELP_NICU",
  HIGH_RISK_PREGNANCY_INFO = "HIGH_RISK_PREGNANCY_INFO",
  LEARN_PARENT_NUTRITION_LIFESTYLE = "LEARN_PARENT_NUTRITION_LIFESTYLE",
  UNDERSTAND_MILESTONES_NEURODIVERGENCE = "UNDERSTAND_MILESTONES_NEURODIVERGENCE",
  HELP_CHILD_NUTRITION_EXERCISE = "HELP_CHILD_NUTRITION_EXERCISE",
  LEARN_CHILD_EMOTIONAL_WELL_BEING = "LEARN_CHILD_EMOTIONAL_WELL_BEING",
  BENEFIT_ADVICE = "BENEFIT_ADVICE",
  LEARN_PUBERTY = "LEARN_PUBERTY",
  POSITIVE_PARENTING_TIPS = "POSITIVE_PARENTING_TIPS",
  HELP_SLEEP_ISSUES = "HELP_SLEEP_ISSUES",
  HELP_INFANT_FEEDING = "HELP_INFANT_FEEDING",
  HELP_INFANT_SLEEP = "HELP_INFANT_SLEEP",
  SUPPORT_WORK_RETURN = "SUPPORT_WORK_RETURN",
  LEARN_FIRST_TRIMESTER = "LEARN_FIRST_TRIMESTER",
  LEARN_SECOND_TRIMESTER = "LEARN_SECOND_TRIMESTER",
  LEARN_THIRD_TRIMESTER = "LEARN_THIRD_TRIMESTER",
  HELP_CHOOSE_BIRTH_LOCATION_PROVIDERS = "HELP_CHOOSE_BIRTH_LOCATION_PROVIDERS",
  HELP_BIRTH_PLANNING = "HELP_BIRTH_PLANNING",
  HELP_PREP_LABOR_DELIVERY = "HELP_PREP_LABOR_DELIVERY",
  LEARN_LACTATION = "LEARN_LACTATION",
  NAVIGATING_DIVORCE_CO_PARENTING = "NAVIGATING_DIVORCE_CO_PARENTING"
  // end: deprecated WWBMH options
}
